import { Component, Input, OnInit } from '@angular/core';
import { GameSettingsService } from '../../game-settings.service';

@Component({
  selector: 'canvas-confetti',
  templateUrl: './canvas-confetti.component.html',
  styleUrls: ['./canvas-confetti.component.scss']
})
export class CanvasConfettiComponent implements OnInit {

  @Input('index') index: number = 0;

  constructor(public gameSettingsService: GameSettingsService) { }

  ngOnInit() {
  }

}
